<template>
    <div
        class="shrink-0 relative group/ipnav"
        :class="[isHeaderIniting && 'header-initing']"
    >
        <AIHistoryNav
            :modelValue="opened"
            @update:modelValue="opened = $event"
            :menus="realNavMenuList"
            :historyMenu="realNavHistory"
            :messages="historyPreTitleMessages"
            theme="dark"
            :responsive="responsive"
            @clickHistory="viewResult"
            @removeHistory="onRemoveHistory"
        >
            <!-- pc端logo -->
            <template #productLogo="{ opened }">
                <div v-if="isHeaderIniting" class="common-nav-wide-ip-logo w-full py-5 relative min-h-[72px] flex items-center justify-center">
                    <div class="bg-transparent w-[196px] h-[32px]"></div>
                </div>
                <div
                    v-else-if="headerServiceRef.whiteLabel && headerServiceRef.customLogoVisible"
                    class="common-nav-wide-ip-logo w-full py-5 relative custom-logo min-h-[72px] flex justify-between items-center"
                >
                    <template v-if="opened">
                        <a
                            :href="logoHref"
                        >
                            <span class="px-3 flex justify-start">
                                <img
                                    :src="headerServiceRef.customLogoUrl"
                                    class="custom-logo-img"
                                />
                            </span>
                        </a>
                        <div class="cursor-pointer pr-3" @click="toggleSidebar">
                            <ToggleIcon class="h-6 w-6 !fill-white" :class="{ 'rotate-180': !opened }" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex justify-center w-full px-3 shrink-0 items-center group cursor-pointer">
                            <a
                                :href="logoHref"
                                class="flex justify-center transition-opacity group-hover:opacity-0 group-hover/ipnav:opacity-0 pointer-events-none"
                            >
                                <span class="px-3 flex justify-center">
                                    <img
                                        :src="headerServiceRef.customLogoUrl"
                                        class="w-6 h-6 object-contain"
                                    />
                                </span>
                            </a>
                            <ElTooltip
                                effect="dark"
                                popperClass="pt-ui-tooltip"
                                :showArrow="false"
                                :offset="16"
                                placement="right"
                                :content="expandText"
                            >
                                <ToggleIcon class="absolute h-6 w-6 !fill-white opacity-0 group-hover:opacity-100 group-hover/ipnav:opacity-100 transition-opacity" :class="{ 'rotate-180': !opened }" @click="toggleSidebar" />
                            </ElTooltip>
                        </div>
                    </template>
                </div>
                <div v-else class="common-nav-wide-ip-logo w-full py-5 relative flex justify-between items-center">
                    <template v-if="opened">
                        <a
                            :href="logoHref"
                        >
                            <span class="px-3 flex justify-start">
                                <!-- <PtIcon  :icon="Logo" /> -->
                                <Logo class="!w-[100px] !h-[30px]"/>
                            </span>
                        </a>
                        <div class="cursor-pointer pr-3"
                             @click="toggleSidebar">
                            <ToggleIcon class="h-6 w-6 !fill-white" :class="{ 'rotate-180': !opened }" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="flex justify-center w-full px-3 shrink-0 items-center group cursor-pointer">
                            <a
                                :href="logoHref"
                                class="flex justify-center group-hover:opacity-0 group-hover/ipnav:opacity-0"
                            >
                                <span class="px-3 flex justify-center">
                                    <MiniLogo class="!w-6 !h-6"/>
                                </span>
                            </a>
                            <ElTooltip
                                effect="dark"
                                popperClass="pt-ui-tooltip"
                                :showArrow="false"
                                :offset="16"
                                placement="right"
                                :content="expandText"
                            >
                                <ToggleIcon class="absolute h-6 w-6 !fill-white opacity-0 group-hover:opacity-100 group-hover/ipnav:opacity-100 outline-none" :class="{ 'rotate-180': !opened }" @click="toggleSidebar" />
                            </ElTooltip>
                        </div>
                    </template>
                </div>
            </template>

            <!-- 移动端logo -->
            <template #logo>
                <a
                    v-if="headerServiceRef.whiteLabel && headerServiceRef.customLogoVisible"
                    :href="logoHref"
                >
                    <img
                        :src="headerServiceRef.customLogoUrl"
                        alt="custom-logo"
                        class="custom-logo-img mobile"
                    >
                </a>
                <a v-else :href="logoHref">
                    <Logo class="!w-[100px] !h-[30px]"/>
                </a>
            </template>
            <template #avatar="{ opened }">
                <div
                    class="eureka-nav-bar-avatar mt-auto border-solid border-white/20 mx-3 flex flex-col items-center gap-2 border-t py-4 relative"
                >
                    <Incognito v-if="incognitoVisible" class="w-full" :opened="opened" :menu="incognitoItem" @handleClick="removeAllHistory"/>
                    <div v-if="!isLogin && opened && showLoginTip" class="hidden absolute bottom-[80px] left-0 lg:block w-[196px] p-3 bg-white text-grey-450 rounded-lg shadow-lg">
                        <img src="./assets/sign-up-bg.png" class="absolute z-1 top-0 left-0 w-full rounded-lg" loading="lazy" />
                        <div class="mb-3 relative z-10 flex justify-between items-center">
                            <div class="font-semibold text-base">{{ t('GuestToMaster.subject') }}</div>
                            <PtIcon icon="SolidCloseMedium" @click="showLoginTip = false" class="!w-6 !h-6 fill-grey-450 cursor-pointer"/>
                        </div>
                        {{ t('GuestToMaster.rights') }}
                        <div class="absolute -bottom-[9px] left-[15px]}">
                            <ArrowDown />
                        </div>
                    </div>
                    <!-- 简单版 EditionTag，无权限控制 -->
                    <IPEditionTag v-if="props.ipNavService?.isShowUpgrade?.value" :open="opened" :onUpgrade="handleUpgrade" :ipNavService="props.ipNavService" />

                    <!-- <template v-if="hasHeaderService"> -->
                    <PtNavUserAvatar :open="opened" :service="headerServiceRef" @clickLogin="handleLogin">
                        <template #userPackageType>
                            <UserPackageType :ipNavService="props.ipNavService" />
                        </template>
                    </PtNavUserAvatar>
                    <!-- </template> -->
                </div>
            </template>
        </AIHistoryNav>

        <!-- 历史记录 Dialog -->
        <HistoryDialog
            ref="historyDialogRef"
            :onClickHistory="viewResult"
            :onNewTasks="handleNewTasks"
            :historyMaps="historyMaps"
        />

        <!-- 确认删除 Dialog -->
        <ConfirmDialog ref="confirmDialogRef" />

        <!-- TODO: 迁移到公用组件库时移除 @eureka 依赖 -->
        <!-- <MobileTag :isLogin="isLogin" /> -->
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, provide } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useHistoryDialog } from './composables/use-history-dialog';
// import { PtAIHistoryNav, PtNavUserAvatar, PtIcon } from 'patsnap-biz';
import PtNavUserAvatar from '@patsnap-biz/nav-user-avatar';
import '@patsnap-biz/nav-user-avatar/lib/style';
import PtIcon from '@patsnap-biz/icon';
import { ElTooltip } from 'element-plus';
import AIHistoryNav from './AIHistoryNav.vue';
import { config, Site, SLD } from '@patsnap-utils/biz';
import ArrowDown from './components/icons/ArrowDown.vue';
import Incognito from './components/Incognito.vue';
import { cn, tw, en, jp } from './locales';
import { INCOGNITO_MENU_ITEM } from './constants';
import { useNavBarState } from './composables/use-navbar-store';
import { useNavBar } from './composables/use-nav-bar';
import { NAV_MENU_TYPE } from './types';
import { get } from 'lodash-es';

import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
import '@patsnap-ui/icon/assets/solid/ArrowRight.svg';
import '@patsnap-ui/icon/assets/solid/AddLarge.svg';
import '@patsnap-ui/icon/assets/userpackage.svg';
import '@patsnap-ui/icon/assets/solid/rocket.svg';
import '@patsnap-ui/icon/assets/solid/NavWorkspace.svg';
import '@patsnap-ui/icon/assets/solid/ChartTopipc.svg';
import '@patsnap-ui/icon/assets/solid/ChartRing.svg';
import '@patsnap-ui/icon/assets/solid/FolderMany.svg';
import '@patsnap-ui/icon/assets/solid/InsightsTechnology.svg';
import Logo from './components/Logo.vue';
import MiniLogo from './components/MiniLogo.vue';
import ToggleIcon from './components/icons/ToggleIcon.vue';
import IPEditionTag from './components/IPEditionTag.vue';
import HistoryDialog from './components/HistoryDialog.vue';
import UserPackageType from './components/UserPackageType.vue';
import ConfirmDialog from './components/ConfirmDialog.vue';

// 异步加载非关键组件
// TODO: 迁移到公用组件库时需要移除 @eureka 依赖，这些是本项目特有组件
// const IPEditionTag = defineAsyncComponent(() => import('@eureka/shared/edition-upgrade/src/components/edition/SimpleEditionTag.vue'));
// const MobileTag = defineAsyncComponent(() => import('@eureka/shared/edition-upgrade/src/components/edition-tag/MobileTag.vue'));
/**
 * 编译时常量声明
 */
// declare const __ENABLE_FEISHU_CLIENT__: boolean | undefined;

const { t } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
});

const props = defineProps<{
    ipNavService?: any,
    navModuleType: NAV_MENU_TYPE
}>();

const { opened } = useNavBarState();

function toggleSidebar() {
    opened.value = !opened.value;
}

function handleUpgrade() {
    props.ipNavService?.config?.onUpgrade?.();
}

const expandText = computed(() => t('AIHistoryNav.open'));

const confirmDialogRef = ref<any>(null);

const { historyPreTitleMessages, viewResult, onRemoveHistory, removeAllHistory, navHistory, historyMaps, navMenuList } = useNavBar({
    navModuleType: props.navModuleType,
    ipNavService: props.ipNavService ?? undefined,
    confirmDialogRef,
});

function handleNewTasks() {
    // 直接使用第一个菜单项（NEW_TASKS）
    const newTasksMenu = navMenuList.value[0];
    if (newTasksMenu) {
        viewResult(newTasksMenu as any);
    } else {
        console.warn('[handleNewTasks] 未找到菜单项');
    }
}

const historyDialogRef = ref<{ openDialog: () => void; closeDialog: () => void } | null>(null);
const { setDialogRef } = useHistoryDialog();

onMounted(() => {
    if (historyDialogRef.value) {
        setDialogRef(historyDialogRef.value);
    }
});

const route = useRoute();

const realNavMenuList = computed(() => {
    return navMenuList.value as any;
});

const realNavHistory = computed(() => {
    return navHistory.value as any;
});

/**
 * 监听路由变化，调用外部的 isActive 回调
 * 监听完整的路由信息，包括 params、query 等
 */
watch(
    () => ({
        path: route.path,
        params: route.params,
    }),
    () => {
        props.ipNavService?.isActiveFromRoute?.(realNavMenuList.value, route as any);
    },
    { immediate: true, deep: true },
);

const headerServiceRef = computed(() => {
    return props.ipNavService?.headerService || {};
});

const isLogin = computed(() => {
    return headerServiceRef.value.userCenterService?.logged ?? false;
});

provide('headerService', headerServiceRef);
provide('isLogin', isLogin);

const logoHref = computed(() => {
    return isLogin.value ? '/home' : '/';
});

headerServiceRef.value?.userCenterService?.beforeLogoutHandlers?.add(function() {
    const service = headerServiceRef.value?.userCenterService;
    if (!service) return;
    service.logged = false;
    service.setUserInfo();
    localStorage.removeItem('patsnap-authorizations');
    const { href } = new Site({ sld: SLD.PASSPORT, pathname: 'logout' });
    const guestPage = `${location.origin}`;
    location.href = `${href}?from=${config.clientName}&redirect_uri=${guestPage}`;
    throw new Error('Logout in NavBar');
});

const showLoginTip = ref(true);

const isHeaderIniting = ref(!!headerServiceRef.value?.deferred?.promise);

headerServiceRef.value?.deferred?.promise?.then(() => {
    isHeaderIniting.value = false;
});

const incognitoItem = computed(() => {
    return {
        ...INCOGNITO_MENU_ITEM,
        title: t(`NavBar.${INCOGNITO_MENU_ITEM.type}`),
        tip: t(`NavBar.${INCOGNITO_MENU_ITEM.type}_TIP`),
    };
});

const incognitoVisible = computed(() => {
    return get(headerServiceRef.value?.account, '_info.incognito_flag') ?? false;
});

const responsive = computed(() => {
    return props.ipNavService?.responsive ?? true;
});

// const isInFeiShuClient = ref(false)

// onMounted(async() => {
//     if (__ENABLE_FEISHU_CLIENT__) {
//         const { clientDeferred } = await import('@eureka/startup/src/feishu-sdk');
//         clientDeferred.promise.then(res => {
//             isInFeiShuClient.value = res.isFeiShu
//         })
//     }
// })

function handleLogin() {
    if (props.ipNavService?.config?.onLogin) {
        props.ipNavService.config.onLogin();
    }
}

</script>

<style lang="scss">
// 覆盖未登录按钮样式
.patsnap-biz-nav-user_center--login {
    padding: 4px 16px 4px 8px !important;
    height: auto !important;
    min-height: 0 !important;
    width: 148px !important;
    border-radius: 4px !important;
}

.patsnap-biz-nav-user_center--not-logged-in {
    & > .th-btn-only-icon {
        height: 34px;
        min-height: 0;
        width: auto !important;
        padding: 0 2px !important;
    }
}

.patsnap-biz-ai-history-nav-collapse {
    .patsnap-biz-nav-user_center--login {
        width: 32px !important;
        height: 32px !important;
        padding: 0 !important;
    }
}

.patsnap-biz-mobile-user-center {
    display: none !important;
}

.patsnap-biz-nav-user-avatar {
    display: block !important;
}
.common-nav-wide-ip-logo {
    &.custom-logo {
        .custom-logo-img {
            max-height: 48px;
            max-width: 100%;
            height: auto;
            width: auto;
            @apply transition-all duration-200;

            &.mobile {
                max-height: 24px !important;
                width: auto;
                height: 24px !important;
                object-fit: contain;
                @apply transition-all duration-200;
            }
        }
    }
}
.nav-history-sub-item {
    &.active-menu-item, &.tippy-content-active {
        span:last-child {
           display: none !important;
        }
    }
}

// 添加移动端特定样式
.patsnap-biz-mobile-nav-bar {
    .custom-logo-img.mobile {
        max-height: 24px !important;
        height: 24px !important;
        width: auto;
        object-fit: contain;
    }
}

.header-initing {
    .patsnap-biz-nav-header, .eureka-nav-bar-avatar {
        display: none;
    }
}
</style>
